export function addToSession(key, content) {
  let previousContent = sessionStorage.getItem(key);
  if (previousContent === null) {
    sessionStorage.setItem(key, JSON.stringify(content));
  } else {
    let contentFromSession = JSON.parse(previousContent);
    if (Array.isArray(contentFromSession)) {
      contentFromSession.map((prev) => [...prev, content]);
      sessionStorage.setItem(key, contentFromSession);
    } else {
      sessionStorage.setItem(key, previousContent);
    }
  }
}

export function setInSession(key, content) {
  sessionStorage.setItem(key, JSON.stringify(content));
}

export function getFromSession(key) {
  let content = sessionStorage.getItem(key);
  if (content !== null) {
    return JSON.parse(content);
  }
}

export function removeFromSession(key) {
  sessionStorage.removeItem(key);
}

/**
 * The order the user is currently paying for. Stored before we hand the browser to the
 * payment provider, because the return pages have to work when opened cold -- the user has
 * been away on another domain and may have refreshed or lost all in-memory state.
 */
const PENDING_ORDER_ID_KEY = "pending_order_id";

export function setPendingOrderId(orderId) {
  if (orderId) {
    setInSession(PENDING_ORDER_ID_KEY, orderId);
  }
}

export function getPendingOrderId() {
  return getFromSession(PENDING_ORDER_ID_KEY) ?? null;
}

export function clearPendingOrderId() {
  removeFromSession(PENDING_ORDER_ID_KEY);
}

export function clearExtractSession() {
  removeFromSession("headers_data");
  removeFromSession("case_info_form");
  removeFromSession("advanced_form");
  removeFromSession("uploaded_files");
  removeFromSession("extract_in_progress");
  removeFromSession("request_id");
}
